import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Fab, Card, InputAdornment } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../components/services/api";
import useDebounce from "../../../libs/hooks/useDebounce";
import SearchData from "../components/SearchData";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
export default function Currency() {
  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 100,
    },
    dense: {
      marginTop: theme.spacing(2),
    },
    menu: {
      width: 100,
    },
  }));

  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [key ,setKey] = useState('')
  
  const debouncedKey = useDebounce(key, 500);const MenuActive = useSelector((state) => state.MenuActive.List);
  /* table data */
  const columns = [
    { field: "CurrencyCode", headerName: "CurrencyCode", width: 300 },
    { field: "CurrencyName", headerName: "CurrencyName", width: 300 },

    {
      field: "Status",
      headerName: "STATUS",
      width: 300,

      valueFormatter: ({ value }) => (value == 1 ? "ACTIVE" : "INACTIVE"),
    },

    {
      field: "Action",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/Setting/EditCurrency/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
                // onClick={onClickEdit}
              >
                Edit
              </Button>
            </Link>
          </>
        );
      },
    },
  ];

  //fetch Data
  const getData = async () => {
    try {
      const data = await api.get(`api/currency/list?keyword=${debouncedKey}`);
      setData(data.data);
      setDataFilter(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getData();

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [debouncedKey]);

  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          สกุลเงิน
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Currency
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Currency
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          sx={{ justifyContent: "end" }}
          style={{ marginTop: "10px" }}
          alignItems="center"
        >
           <TextField
           InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            disableUnderline: true,
          }}
          label="Search"
          onChange={e => setKey(e.target.value)}
          size="small"
        />
          
      
          {/* <SearchData name={data} onsetData={setDataFilter} /> */}
        </Grid>

        <Box
          sx={{
            height: 650,
            width: "100%",
            marginTop: "10px",
            "& .Active": {
              color: "#28A745",
            },
            "& .Inactive": {
              color: "#F53C56",
            },
          }}
        >
          <DataGrid
            getRowId={(r) => r.CurrencyId}
            rows={dataFilter}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
            getCellClassName={(params) => {
              if (params.field === "Status") {
                return params.value == 1 ? "Active" : "Inactive";
              }
            }}
          />
        </Box>
      </Card>
      {MenuActive.find((x) => x.ActionNo === "A102") && (
        <Link to="/Setting/AddCurrency">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
      )}
    </div>
  );
}
